import { teams } from '../constants/actions'

const initialState = {
  teamsByCode: [],
  teamsByUser: [],
  allTeamCodes: [],
  teamsInEvent: [],
  teamFormType: 'Join A Team',
  teamLogoImage: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case teams.SET_TEAMS_BY_CODE: {
      return {
        ...state,
        teamsByCode: action.payload.map(t => ({
          ...t,
          label: t.name,
          value: t.name,
        })),
      }
    }
    case teams.SET_TEAMS_BY_USER: {
      return {
        ...state,
        teamsByUser: [
          {
            key: 'TeamsByUser',
            value: (action.payload || []).map(t => ({
              ...t,
              label: t.name,
              value: t.name,
            })),
            key_prefix: '',
          },
        ],
      }
    }
    case teams.SET_ALL_TEAM_CODES: {
      return {
        ...state,
        allTeamCodes: action.payload,
      }
    }
    case teams.SET_TEAMS_IN_EVENT: {
      return {
        ...state,
        teamsInEvent: action.payload,
      }
    }
    case teams.SET_TEAM_FORM_TYPE: {
      return {
        ...state,
        teamFormType: action.payload,
      }
    }
    case teams.SET_TEAM_LOGO: {
      return {
        ...state,
        teamLogoImage: action.payload,
      }
    }
    default:
      return state
  }
}
